<template>
  <CRow>
    <CModal
        :title="
        submitType === 'Update' ? $lang.city.crud.edit : $lang.city.crud.create
      "
        size="lg"
        :show.sync="largeModal"
        :no-close-on-backdrop="true"
        color="primary"
    >
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>{{
          err_msg
        }}
      </CAlert>
      <CForm novalidate @submit.prevent="onSubmit">
        <CCardBody>
          <div
              class="form-group"
              :class="{ 'form-group--error': $v.city.countryName.$error }"
          >
            <label class="form__label"
            >{{ $lang.city.form.countryName }}
              <required_span/>
            </label>
            <v-select
                :options="CountryOptions"
                v-model="city.countryName"
                @option:selected="loadState"
            ></v-select>
            <small
                class="error"
                v-if="$v.city.countryName.$error && !$v.city.countryName.required"
            >{{ $lang.city.validation.required.countryName }}</small
            >
          </div>
          <div
              class="form-group"
              :class="{ 'form-group--error': $v.city.stateName.$error }"
          >
            <label class="form__label"
            >{{ $lang.city.form.stateName }}
              <required_span/>
            </label>
            <v-select :options="StateOptions" v-model="city.stateName">
            </v-select>
            <small
                class="error"
                v-if="$v.city.stateName.$error && !$v.city.stateName.required"
            >{{ $lang.city.validation.required.stateName }}</small
            >
          </div>
          <div
              class="form-group"
              :class="{ 'form-group--error': $v.city.name.$error }"
          >
            <label class="form__label"
            >{{ $lang.city.form.name }}
              <required_span/>
            </label>
            <input
                :maxlength="maxlength.name"
                :placeholder="$lang.city.form.name"
                class="form-control"
                v-model="city.name"
            />
            <small
                class="error"
                v-if="$v.city.name.$error && !$v.city.name.required"
            >{{ $lang.city.validation.required.name }}</small
            >
          </div>

          <div class="form-group" :class="{ 'form-group--error': '' }">
            <label class="form__label">{{ $lang.city.form.isActive }} </label>

            <input
                type="checkbox"
                :placeholder="$lang.city.form.isActive"
                :value="1"
                @change="changedIsActive"
                v-model="city.isActive"
            />
          </div>
        </CCardBody>
        <CCardFooter>
          <CButton
              type="submit"
              size="sm"
              color="primary"
              :disabled="submitted"
          >
            <CIcon name="cil-check-circle"/>
            {{ $lang.buttons.general.crud.submit }}
          </CButton>
        </CCardFooter>
      </CForm>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none"
        >Discard
        </CButton
        >
        <CButton
            @click="darkModal = false"
            color="success"
            style="display: none"
        >Accept
        </CButton
        >
      </template>
    </CModal>

    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.city.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButton
                    color="primary"
                    v-on:click="createTableRow"
                    v-if="checkPermission('create-city')"
                    style="margin-right: 10px"
                >
                  {{ $lang.buttons.general.crud.create }}
                </CButton>
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'City')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
                <BeforeFilter
                    :filterShow="toggleFilterValue"
                    @getFilterToggle="switchFilter"
                ></BeforeFilter>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <transition name="fade">
            <CRow v-if="toggleFilterValue">
              <CCol sm="4">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.city.form.countryName
                    }}</label>
                  <v-select
                      :options="CountryOptions"
                      v-model="city.countryName"
                      @option:selected="loadState"
                  >
                  </v-select>
                </div>
              </CCol>
              <CCol sm="4">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.city.form.stateName
                    }}</label>
                  <v-select :options="StateOptions" v-model="city.stateName">
                  </v-select>
                </div>
              </CCol>
              <CCol sm="4">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton>
                  &nbsp;
                  <CButton
                      color="danger"
                      size="sm"
                      @click="resetFilter()"
                      v-c-tooltip="$lang.common.filter.button.cancel"
                  >
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </transition>
          <CAlert
              color="success"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/cities/list"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'City')"
          >
            <template #status="data">
              <CBadge :color="statusBudget(data.row.status)">{{ data.row.status }}</CBadge>
            </template>
            <template #name="data">
              <span :title="data.row.name">{{
                  trimfunction(data.row.name, 20)
                }}</span>
            </template>
            <template #country="data">
              <span :title="data.row.country.name">{{
                  trimfunction(data.row.country.name, 20)
                }}</span>
            </template>
            <template #state="data">
              <span :title="data.row.state.name">{{ trimfunction(data.row.state.name, 20) }}</span>
            </template>
            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.edit"
                  v-on:click="editTableRow(data.row.id)"
                  v-if="checkPermission('edit-city')"
              >
                <i class="fas fa-pencil-alt"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('delete-city')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {state, city, country} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {minLength, required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueToasted from "vue-toasted";
import BeforeFilter from "../BeforeFilterOpen";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";

function toast({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);
export default {
  name: "CityItem",
  mixins: [Mixin],
  components: {
    required_span,
    BeforeFilter,
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      json_data: [],
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      err_msg: "",
      largeModal: false,
      submitType: "",

      alertMessage: "",
      dismissCountDown: 0,
      CountryOptions: [],
      countryModule: country,
      stateModule: state,
      module: city,
      dismissCountDownS: 0,
      StateOptions: [],
      city: {
        countryName: "",
        stateName: "",
        name: "",
        isActive: 1,
      },
      maxlength: {
        name: Maxlength.city.name,
      },
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      columns: ["country", "state", "name", "status", "actions"],
      data: [],
      options: {
        headings: {
          country: this.$lang.city.table.countryName,
          state: this.$lang.city.table.stateName,
          name: this.$lang.city.table.name,
          status: this.$lang.city.table.isActive,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["country", "state", "name"],
        sortable: ["country", "state", "name"],
        filterable: ["country", "state", "name"],
      },
    };
  },
  validations: {
    city: {
      name: {
        required,
        minLength: minLength(1),
      },
      countryName: {
        required,
      },
      stateName: {
        required,
      },
    },
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    // this.loadData();
    axios.get(this.listUrlApi(this.countryModule)).then((response) => {
      response.data.data.map(function (value, key) {
        self.CountryOptions.push({value: value.id, label: value.name});
      });
    });
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    /* get from child component */
    switchFilter(show) {
      this.toggleFilterValue = show;
    },

    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.city.isActive = 1;
      } else {
        self.city.isActive = 0;
      }
    },

    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                let responseData = response.data;
                if (responseData.code === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.dismissCountDownS = 10;
                } else {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "danger";
                  self.dismissCountDownS = 10;
                }
              }).catch(function (error) {
            let data;
            if (error.response.data.error) {
              data = error.response.data.error.toString();
            } else {
              data = error.response.data.message;
            }
            self.alertMessage = data;
            self.messageColor = "danger";
            self.dismissCountDownS = 10;
          });
        }
      });
    },
    createTableRow() {
      let self = this;
      self.$v.$reset();
      self.submitType = "Create";
      self.city.name = "";
      self.city.stateName = "";
      self.city.countryName = "";
      self.largeModal = true;
    },
    editTableRow(item) {
      let self = this;
      self.$v.$reset();
      self.submitType = "Update";
      const id = item;
      self.editId = item;
      axios
          .get(this.viewUrlApi(this.module, id), self.model)
          .then(function (response) {
            if (response) {
              let responseData = response.data.data;
              self.city.name = responseData.name;
              self.city.isActive = responseData.isActive;
              self.city.countryName = {
                value: responseData.country.id,
                label: responseData.country.name,
              };
              self.city.stateName = {
                value: responseData.state.id,
                label: responseData.state.name,
              };
            } else {
              self.data = [];
            }
          });
      self.largeModal = true;
    },

    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadState() {
      let self = this;
      const postData = {countryId: self.city.countryName};
      self.city.stateName = '';
      axios
          .post(this.filterUrApi(this.stateModule), postData)
          .then((response) => {
            self.StateOptions = [];
            response.data.data.map(function (value, key) {
              self.StateOptions.push({value: value.id, label: value.name});
            });
          });
    },
    loadData() {
      let self = this;
      const postData = {
        countryId: self.city.countryName,
      };
      axios
          .post(this.listUrlApi(this.module), postData)
          .then(function (response) {
            if (response.status === 200) {
              self.data = response.data.data;
            }
          });
    },
    applyFilter() {
      store.commit("showLoader", true); // Loader Off
      this.$refs.myTable.customQueries = {
        countryId:
            this.city.countryName !== null &&
            Object.keys(this.city.countryName).length > 0 &&
            this.city.countryName.value > 0
                ? this.city.countryName.value
                : "",
        stateId:
            this.city.countryName !== null &&
            Object.keys(this.city.stateName).length > 0 &&
            this.city.stateName.value > 0
                ? this.city.stateName.value
                : "",
      };
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      store.commit("showLoader", true); // Loader Off
      this.city.countryName = {};
      this.city.stateName = {};
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
    onSubmit() {
      let self = this;
      this.$v.city.$touch();
      if (this.$v.city.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";
        if (this.submitType === "Update") {
          setTimeout(() => {
            let self = this;
            const postData = {
              name: self.city.name,
              countryId: self.city.countryName.value,
              stateId: self.city.stateName.value,
              isActive: self.city.isActive,
            };
            axios
                .post(this.updateUrlweb(this.module, self.editId), postData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  let data;
                  if (error.response.data.error) {
                    data = error.response.data.error.toString();
                  } else {
                    data = error.response.data.message;
                  }
                  self.err_msg = data;
                  self.dismissCountDown = 10;
                  self.submitted = false; //Enable Button
                });
          }, 500);
        } else {
          setTimeout(() => {
            let self = this;
            const postData = {
              name: self.city.name,
              countryId: self.city.countryName.value,
              stateId: self.city.stateName.value,
              isActive: self.city.isActive,
            };
            axios
                .post(this.createUrlWeb(this.module), postData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  let data;
                  if (error.response.data.error) {
                    data = error.response.data.error.toString();
                  } else {
                    data = error.response.data.message;
                  }
                  self.err_msg = data;
                  self.dismissCountDown = 10;
                  self.submitted = false; //Enable Button
                });
          }, 500);
        }
      }
    },
  },
};
</script>
